import React from 'react';
import { connect, useSelector } from "react-redux";
import { reduxForm, getFormValues } from "redux-form";
import { get, isFunction } from "lodash";

const XForm = (props) => {
    const {
        attribute,
        searchForm,
        /** 
         * State coming from reducer through connect
         */
        invalid,
        change,
        formValues,
        abortItems, 
        rowCount,
        handleSubmit
    } = props;

    const { fetching } = useSelector((state) => get(state.grid, attribute, {}));

    return (
        <form name="search" onSubmit={handleSubmit}>
            {isFunction(searchForm) && searchForm({ change, formValues, invalid, fetching, abortItems, rowCount })}
            {!isFunction(searchForm) && searchForm}
        </form>
    )
}

const mapStateToProps = (state, ownprops) => {
    const { grid } = state;
    const { attribute = "list", defaultFilters, formName } = ownprops;

    return {
        form: formName,
        formValues: getFormValues(formName)(state) || {},
        initialValues: {
            ...defaultFilters || {},
            ...get(grid, `${attribute}.searchParams`, {})
        }
    }
}

export default connect(mapStateToProps)(reduxForm({
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    onChange: (values, dispatch, props) => {
        props.onFormChange(values);
    },
})(XForm));